import { render } from "./RegistrationConfirm.vue?vue&type=template&id=6fe10477"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script